import React from 'react';

const Learn = ({topics = []}) => {
  const colorClasses = [
    'bg-blue-100 text-blue-800',
    'bg-green-100 text-green-800',
    'bg-yellow-100 text-yellow-800',
    'bg-purple-100 text-purple-800',
    'bg-pink-100 text-pink-800',
    'bg-orange-100 text-orange-800',
    'bg-teal-100 text-teal-800',
  ];

  return (
    <div className="p-6 mt-2 bg-gray-90">
      <h2 className="mb-3 text-xl font-stack-text 900">Etiquetas del curso</h2>
      <ul className="flex flex-wrap gap-2">
        {
          topics.map((topic, index) => {
            const colorClass = colorClasses[index % colorClasses.length];
            return (
              <li
                key={index}
                className={`px-3 py-1 text-sm font-medium rounded-full ${colorClass}`}
              >
                {topic}
              </li>
            );
          })
        }
      </ul>
    </div>
  );
};

export default Learn;
